<template lang="pug">
v-snackbar(v-model="showSnackbar" vertical :timeout="timeoutSnackbar" light :color="color") 
  pre(style="word-wrap: break-word; white-space: pre-wrap") {{ message }}
  template(#action="{ attrs }")
    v-btn(v-bind="attrs" text color="cancelColor" @click="closeSnackbar()") Fechar  
</template>

<script>
export default {
  name: "SnackbarComponent",
  data() {
    return {
      showSnackbar: false,
      message: "",
      timeoutSnackbar: 4000,
      color: "lighterSuccess",
    };
  },
  computed: {},
  methods: {
    show(data) {
      this.message = data.message || "Mensagem padrão";
      this.color = data.color || "lighterSuccess";
      this.timeoutSnackbar = data.timeout || 4000;
      this.showSnackbar = true;
    },
    closeSnackbar() {
      this.showSnackbar = false;
    },
  },
};
</script>

<style lang="sass" scoped>
pre
  font-family: Poppins, sans-serif
</style>
